const spanishPhoneRegex = /^(?:\+34|0034|34)?[6-9]\d{8}$/;
const andorraPhoneRegex = /^((\+376)|(00376)|(76))\d{6}$/;
const francePhoneRegex = /^((\+33|0033)|0)[1-9](\d{8})$/;

const validateSpanishPhoneFormat = (phone) => spanishPhoneRegex.test(phone);
const validateAndorraPhoneFormat = (phone) => andorraPhoneRegex.test(phone);
const validateFrancePhoneFormat = (phone) => francePhoneRegex.test(phone);
const validateFormat = (phone) =>
  validateSpanishPhoneFormat(phone) ||
  validateAndorraPhoneFormat(phone) ||
  validateFrancePhoneFormat(phone);
export default {
  validateFormat,
};
